<template>
  <div class="moduleStyle minHeight">
    <!-- <pageTitle title="目标库存"> </pageTitle> -->

    <!-- 自定义 Tabs -->
    <div class="tabs">
      <ul>
        <li
          :class="activeId == item.val ? 'tabs_active' : ''"
          @click="changeTabs(item.val)"
          v-for="item in tabslist"
          :key="item.val"
        >
          {{ item.label }}
        </li>
      </ul>
      <div class="tabsbutton" v-if="activeId == 1">
        <el-button type="warning" size="small" @click="initTargets">初始化</el-button>
        <el-button type="primary" size="small" :disabled="!hasChangedData" @click="saveAllChanged">全部更新</el-button>
        <el-button type="danger" size="small" :disabled="!multipleSelection.length" @click="batchRemove">批量移除</el-button>
        <el-button type="success" size="small" icon="el-icon-download" @click="exportData">导出</el-button>
      </div>
      <div class="tabsbutton" v-if="activeId == 3">
        <el-button type="primary" size="small" :disabled="!removedMultipleSelection.length" @click="batchRestore">批量恢复</el-button>
      </div>
    </div>
    <div style="height: 20px"></div>

    <!-- 目标库存管理 Tab -->
    <div class="table" v-if="activeId == 1">
      <basicList ref="table" :config="basicListconfig" @search="searchEvent" @sortChange="sortChange">
      <template v-slot:additionalFeatures>
        <div class="table">
          <el-table
            :data="basicListconfig.data"
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            style="width: 100%"
            row-key="item_id"
            resizable
            border
            :show-overflow-tooltip="true"
            :row-class-name="tableRowClassName"
            @sort-change="handleSortChange"
            v-loading="basicListconfig.loading"
            element-loading-text="数据加载中..."
            element-loading-spinner="el-icon-loading"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <div class="empty-data">
                <i class="el-icon-document" style="font-size: 60px; color: #dcdfe6;"></i>
                <p>暂无数据</p>
              </div>
            </template>
            <el-table-column type="selection" width="48" fixed="left" />
            <el-table-column
              min-width="200"
              prop="item_name_tag"
              fixed="left"
              label="品名"
            >
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.item_name || scope.row.item_name_tag" placement="top">
                  <span>{{ scope.row.item_name_tag || scope.row.item_name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column width="120" prop="parent_class" label="主类" />
            <el-table-column width="120" prop="class_name" label="子类" />
            <el-table-column width="100" prop="sale_30_num" label="月销量" sortable="custom" :sort-orders="['descending', 'ascending', null]" />
            <el-table-column width="100" label="目标">
              <template slot-scope="scope">
                {{ calculateTarget(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column width="120" label="达成率" sortable="custom" prop="achievement_rate" :sort-orders="['descending', 'ascending', null]">
              <template slot-scope="scope">
                <span :style="{ color: getAchievementRateColor(scope.row) }">
                  {{ calculateAchievementRate(scope.row) }}
                </span>
              </template>
            </el-table-column>

            <el-table-column label="目标库存调整策略" align="center">
              <el-table-column width="90" label="当前" sortable="custom" prop="item_stock_target" :sort-orders="['descending', 'ascending', null]">
                <template slot-scope="scope">
                  {{ scope.row.item_stock_target || 0 }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="周转率" sortable="custom" prop="turnoverdays" :sort-orders="['descending', 'ascending', null]">
                <template slot-scope="scope">
                  {{ scope.row.turnoverdays || 0 }}
                </template>
              </el-table-column>
              <el-table-column width="120" label="调整策略">
                <template slot-scope="scope">
                  <el-select
                    size="small"
                    v-model="scope.row.target_strategy"
                    placeholder="请选择"
                    @change="onTargetStrategyChange(scope.row)"
                    :style="{ backgroundColor: getStrategyColor(scope.row.target_strategy) }"
                    :class="'strategy-select-' + scope.row.target_strategy"
                  >
                    <el-option label="不调" value="不调"></el-option>
                    <el-option label="快调" value="快调"></el-option>
                    <el-option label="手调" value="手调"></el-option>
                    <el-option label="不变" value="不变"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column width="110" label="推荐">
              <template slot-scope="scope">
                <el-input
                    v-if="scope.row.target_strategy === '手调'"
                  size="small"
                    v-model="scope.row.recommend_target"
                    @input="onRecommendChange(scope.row)"
                    @blur="onTargetBlur(scope.row)"
                  />
                  <span v-else>{{ scope.row.recommend_target || 0 }}</span>
              </template>
            </el-table-column>
              <el-table-column width="120" label="推荐周转率">
              <template slot-scope="scope">
                <el-input
                    v-if="scope.row.target_strategy === '手调'"
                  size="small"
                    v-model="scope.row.recommend_turnover"
                    @input="onRecommendChange(scope.row)"
                    @blur="onTurnoverBlur(scope.row)"
                  />
                  <span v-else>{{ scope.row.recommend_turnover || 0 }}</span>
              </template>
              </el-table-column>
              <el-table-column width="120" label="预估达成率">
                <template slot-scope="scope">
                  {{ calculateEstimatedRate(scope.row) }}
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column label="安全库存调整策略" align="center">
              <el-table-column width="90" label="当前" sortable="custom" prop="item_stock_safe" :sort-orders="['descending', 'ascending', null]">
                <template slot-scope="scope">
                  {{ scope.row.item_stock_safe || 0 }}
                </template>
              </el-table-column>
              <el-table-column width="120" label="调整策略">
                <template slot-scope="scope">
                  <el-select
                    size="small"
                    v-model="scope.row.safe_strategy"
                    placeholder="请选择"
                    @change="onSafeStrategyChange(scope.row)"
                    :style="{ backgroundColor: getStrategyColor(scope.row.safe_strategy) }"
                    :class="'strategy-select-' + scope.row.safe_strategy"
                  >
                    <el-option label="不调" value="不调"></el-option>
                    <el-option label="快调" value="快调"></el-option>
                    <el-option label="手调" value="手调"></el-option>
                    <el-option label="不变" value="不变"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column width="120" label="补货次数" sortable="custom" prop="purchase_30_count" :sort-orders="['descending', 'ascending', null]">
                <template slot-scope="scope">
                  <el-input
                    v-if="scope.row.safe_strategy === '手调'"
                    size="small"
                    v-model="scope.row.safe_purchase_freq"
                    @input="onSafePurchaseChange(scope.row)"
                    @blur="onSafePurchaseBlur(scope.row)"
                  />
                  <span v-else>{{ scope.row.safe_purchase_freq || 0 }}</span>
                </template>
              </el-table-column>
              <el-table-column width="110" label="推荐">
                <template slot-scope="scope">
                  <el-input
                    v-if="scope.row.safe_strategy === '手调'"
                    size="small"
                    v-model="scope.row.recommend_safe"
                    @input="onSafeRecommendChange(scope.row)"
                    @blur="onSafeRecommendBlur(scope.row)"
                  />
                  <span v-else>{{ scope.row.recommend_safe || 0 }}</span>
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column label="操作" width="160" fixed="right">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row._changed"
                  type="primary"
                  size="mini"
                  @click="saveOne(scope.row)"
                >更新</el-button>
                <el-button
                  type="danger"
                  size="mini"
                  @click="removeOne(scope.row)"
                >移除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="table_footer" v-if="basicListconfig.isPage">
            <p class="table_footer_total">共{{ basicListconfig.total }}项数据</p>
            <el-pagination
              background
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :page-sizes="[10, 50, 100, 500]"
              :current-page.sync="basicListconfig.searchParameters.page"
              :page-size="basicListconfig.searchParameters.limit"
              layout="sizes,prev, pager, next"
              :total="basicListconfig.total"
            />
          </div>
        </div>
      </template>
    </basicList>
    </div>

    <!-- 修改日志 Tab -->
    <div class="table" v-if="activeId == 2">
      <basicList ref="logTable" :config="logListconfig" @search="searchLogEvent">
        <template v-slot:additionalFeatures>
          <div class="table">
            <el-table
              :data="logListconfig.data"
              header-cell-class-name="headerCellStyle"
              cell-class-name="cellStyle"
              style="width: 100%"
              border
              :show-overflow-tooltip="true"
              v-loading="logListconfig.loading"
              element-loading-text="数据加载中..."
              element-loading-spinner="el-icon-loading"
            >
              <template slot="empty">
                <div class="empty-data">
                  <i class="el-icon-document" style="font-size: 60px; color: #dcdfe6;"></i>
                  <p>暂无数据</p>
                </div>
              </template>
                <el-table-column
                  width="180"
                  prop="change_time"
                  label="修改时间"
                  sortable
                />
                <el-table-column
                  width="200"
                  prop="item_name_tag"
                  label="商品名称"
                >
                  <template slot-scope="scope">
                    <el-tooltip :content="scope.row.item_name || scope.row.item_name_tag" placement="top">
                      <span>{{ scope.row.item_name_tag || scope.row.item_name }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="400"
                  label="变更内容"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.changes && scope.row.changes.length">
                      <el-tag
                        v-for="(change, index) in scope.row.changes"
                        :key="index"
                        type="info"
                        size="small"
                        style="margin: 2px;"
                      >
                        {{ change.field_name }}: {{ change.old_value }} → {{ change.new_value }}
                      </el-tag>
                    </div>
                    <span v-else style="color: #999;">无变更</span>
                  </template>
                </el-table-column>
                <el-table-column
                  width="120"
                  prop="operator_name"
                  label="操作人"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.operator_name || '系统' }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  width="200"
                  prop="remark"
                  label="备注"
                />
              </el-table>

              <div class="table_footer" v-if="logListconfig.isPage">
                <p class="table_footer_total">共{{ logListconfig.total }}项数据</p>
                <el-pagination
                  background
                  @current-change="handleLogCurrentChange"
                  @size-change="handleLogSizeChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :current-page.sync="logListconfig.searchParameters.page"
                  :page-size="logListconfig.searchParameters.limit"
                  layout="sizes,prev, pager, next"
                  :total="logListconfig.total"
                />
              </div>
            </div>
          </template>
        </basicList>
    </div>

    <!-- 已移除商品 Tab -->
    <div class="table" v-if="activeId == 3">
      <basicList ref="removedTable" :config="removedListconfig" @search="searchRemovedEvent">
        <template v-slot:additionalFeatures>
          <div class="table">
            <el-table
              :data="removedListconfig.data"
              header-cell-class-name="headerCellStyle"
              cell-class-name="cellStyle"
              style="width: 100%"
              border
              :show-overflow-tooltip="true"
              v-loading="removedListconfig.loading"
              element-loading-text="数据加载中..."
              element-loading-spinner="el-icon-loading"
              @selection-change="handleRemovedSelectionChange"
            >
              <template slot="empty">
                <div class="empty-data">
                  <i class="el-icon-document" style="font-size: 60px; color: #dcdfe6;"></i>
                  <p>暂无数据</p>
                </div>
              </template>
              <el-table-column type="selection" width="48" />
              <el-table-column
                min-width="200"
                prop="item_name_tag"
                label="商品名称"
              >
                <template slot-scope="scope">
                  <el-tooltip :content="scope.row.item_name || scope.row.item_name_tag" placement="top">
                    <span>{{ scope.row.item_name_tag || scope.row.item_name }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column width="150" prop="item_number" label="商品编号" />
              <el-table-column width="120" prop="parent_class" label="主类" />
              <el-table-column width="120" prop="class_name" label="子类" />
              <el-table-column width="180" prop="removed_time" label="移除时间" />
              <el-table-column width="120" prop="operator_name" label="操作人">
                <template slot-scope="scope">
                  <span>{{ scope.row.operator_name || '系统' }}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="200" prop="remark" label="移除原因" />
              <el-table-column label="操作" width="120" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="restoreOne(scope.row)"
                  >恢复</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="table_footer" v-if="removedListconfig.isPage">
              <p class="table_footer_total">共{{ removedListconfig.total }}项数据</p>
              <el-pagination
                background
                @current-change="handleRemovedCurrentChange"
                @size-change="handleRemovedSizeChange"
                :page-sizes="[10, 20, 50, 100]"
                :current-page.sync="removedListconfig.searchParameters.page"
                :page-size="removedListconfig.searchParameters.limit"
                layout="sizes,prev, pager, next"
                :total="removedListconfig.total"
              />
            </div>
          </div>
        </template>
      </basicList>
    </div>
  </div>
 </template>

<script>
import { mapGetters } from "vuex";
import { getRoles } from "@/utils";
import {
  getTargetStockList,
  getChangeHistory,
  exportTargetStock,
  removeItem,
  batchRemoveItems,
  restoreItem,
  batchRestoreItems,
  getRemovedList,
  getRemovedInitInfo
} from "@/api/inventoryFlow";
import { getshoplist, userPermissionShopGetList, itemClassGetList } from "@/api/basicConfiguration";
import axios from "axios";
import { getSession } from "@/utils/cookie";

const defaultParameters = {
  page: 1,
  limit: 10,
};

export default {
  name: "stockTarget",
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopId: null,
      activeId: 1, // 当前激活的tab
      tabslist: [
        {
          label: "目标库存管理",
          val: 1,
        },
        {
          label: "修改日志",
          val: 2,
        },
        {
          label: "已移除商品",
          val: 3,
        },
      ],
      multipleSelection: [], // 选中的行数据
      removedMultipleSelection: [], // 已移除列表选中的行

      basicListconfig: {
        table: true,
        loading: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            key: "class_id",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
        ],
        data: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },

      // 修改日志配置
      logListconfig: {
        table: true,
        loading: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
          },
          {
            label: "品名",
            type: "input",
            key: "keywords",
          },
          {
            label: "开始日期",
            type: "date",
            key: "start_date",
            value: "",
          },
          {
            label: "结束日期",
            type: "date",
            key: "end_date",
            value: "",
          },
        ],
        data: [],
        isPage: true,
        total: 0,
        searchParameters: {
          page: 1,
          limit: 20,
          shop_id: "",
          keywords: "",
          start_date: "",
          end_date: "",
        },
      },

      // 已移除商品配置
      removedListconfig: {
        table: true,
        loading: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            key: "class_id",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
        ],
        data: [],
        isPage: true,
        total: 0,
        searchParameters: {
          page: 1,
          limit: 20,
          shop_id: "",
          keywords: "",
          class_id: "",
        },
      },
      apiBase: process.env.VUE_APP_BASE_API || 'https://erp.zuizhenshi.cn',
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;

    this.obtainDataSource().then(() => {
      // 默认选择主门店，参考productAnalysis页面
      this.basicListconfig.searchParameters.shop_id = JSON.parse(getRoles()).shop_id;
      this.getlist();
    });
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
    // 判断是否有修改的数据
    hasChangedData() {
      return this.basicListconfig.data.some(item => item._changed);
    },
  },
  methods: {
    // 选择行变化
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 已移除列表选择行变化
    handleRemovedSelectionChange(val) {
      this.removedMultipleSelection = val;
    },
    // 表格行样式：标记已修改的行
    tableRowClassName({row, rowIndex}) {
      if (row._changed) {
        return 'row-changed';
      }
      return '';
    },
    // 表格排序变化
    handleSortChange({ column, prop, order }) {
      console.log('排序变化：', { prop, order });

      if (!prop) return;

      if (order) {
        // 有排序方向
        this.basicListconfig.searchParameters.order_by = prop;
        // order 值：ascending（升序）、descending（降序）
        this.basicListconfig.searchParameters.order_type = order === 'ascending' ? 'asc' : 'desc';
      } else {
        // 取消排序
        delete this.basicListconfig.searchParameters.order_by;
        delete this.basicListconfig.searchParameters.order_type;
      }

      this.basicListconfig.searchParameters.page = 1;
      this.getlist();
    },
    // basicList 组件的排序事件
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_by = data.prop;
      // 根据排序方向传递 asc 或 desc
      this.basicListconfig.searchParameters.order_type = data.order === 'ascending' ? 'asc' : 'desc';
      this.getlist();
    },
    // 计算目标 = 周转率 * 当前目标库存
    calculateTarget(row) {
      const turnover = Number(row.turnoverdays) || 0;
      const target = Number(row.item_stock_target) || 0;
      return turnover * target;
    },
    // 获取达成率颜色：达成100%为红色，未达成100%为绿色
    getAchievementRateColor(row) {
      const sale = Number(row.sale_30_num) || 0;
      const target = this.calculateTarget(row);
      if (target === 0) return '#67C23A'; // 绿色
      const rate = (sale / target * 100);
      return rate >= 100 ? '#F56C6C' : '#67C23A'; // 红色 : 绿色
    },
    // 获取调整策略颜色
    getStrategyColor(strategy) {
      const colorMap = {
        '不调': '#E6F7FF',   // 浅蓝色
        '快调': '#FFF7E6',   // 浅橙色
        '手调': '#F0F5FF',   // 浅紫色
        '不变': '#F5F5F5'    // 浅灰色
      };
      return colorMap[strategy] || '#FFFFFF';
    },
    // 计算达成率 = 月销量 / 目标 * 100%
    calculateAchievementRate(row) {
      const sale = Number(row.sale_30_num) || 0;
      const target = this.calculateTarget(row);
      if (target === 0) return '0.00%';
      const rate = (sale / target * 100).toFixed(2);
      return `${rate}%`;
    },
    // 计算预估达成率 = 月销量 / (推荐周转率 * 推荐)
    calculateEstimatedRate(row) {
      const sale = Number(row.sale_30_num) || 0;
      const recommendTarget = Number(row.recommend_target) || 0;
      const recommendTurnover = Number(row.recommend_turnover) || 0;
      const denominator = recommendTurnover * recommendTarget;
      if (denominator === 0) return '0.00%';
      const rate = (sale / denominator * 100).toFixed(2);
      return `${rate}%`;
    },
    // 目标库存调整策略变化
    onTargetStrategyChange(row) {
      const strategy = row.target_strategy;
      const sale = Number(row.sale_30_num) || 0;
      const currentTarget = Number(row.item_stock_target) || 0;
      const turnover = Number(row.turnoverdays) || 1;

      if (strategy === '不调') {
        // 不调：推荐周转率=（月销量/当前），推荐不变
        row.recommend_target = currentTarget;
        if (currentTarget > 0) {
          row.recommend_turnover = (sale / currentTarget).toFixed(2);
        } else {
          row.recommend_turnover = 0;
        }
        // 标记数据已修改
        this.$set(row, '_changed', true);
      } else if (strategy === '快调') {
        // 快调：推荐=（月销量/周转率），推荐周转率不变
        row.recommend_turnover = turnover;
        if (turnover > 0) {
          row.recommend_target = Math.round(sale / turnover);
        } else {
          row.recommend_target = 0;
        }
        // 标记数据已修改
        this.$set(row, '_changed', true);
      } else if (strategy === '手调') {
        // 手调：将推荐和推荐周转率变成可编辑输入框
        // 保持当前值不变，允许用户手动输入
        // 标记数据已修改
        this.$set(row, '_changed', true);
      } else if (strategy === '不变') {
        // 不变：恢复默认值，清除修改标记
        row.recommend_target = currentTarget;
        row.recommend_turnover = turnover;
        // 清除修改标记（如果安全库存也是不变状态）
        if (row.safe_strategy === '不变') {
          this.$set(row, '_changed', false);
        }
      }

      // 如果安全库存是"不调"模式，需要重新计算补货次数
      if (row.safe_strategy === '不调') {
        const recommendTarget = Number(row.recommend_target) || 0;
        const currentSafe = Number(row.item_stock_safe) || 0;
        const turnover = Number(row.recommend_turnover) || Number(row.turnoverdays) || 0;
        row.recommend_safe = currentSafe;
        const denominator = recommendTarget - currentSafe;
        if (denominator > 0) {
          let calcFreq = Math.ceil(sale / denominator);
          // 补货次数不能小于周转率，不能小于0
          row.safe_purchase_freq = Math.max(calcFreq, turnover, 0);
        } else {
          row.safe_purchase_freq = Math.max(turnover, 0);
        }
      }

      // 如果安全库存是"快调"模式，需要重新计算推荐安全库存
      if (row.safe_strategy === '快调') {
        const recommendTarget = Number(row.recommend_target) || 0;
        const turnover = Number(row.recommend_turnover) || Number(row.turnoverdays) || 0;
        let purchaseFreq = Number(row.safe_purchase_freq) || 1;
        // 验证并修正补货次数：不能小于周转率，不能小于0
        let validFreq = Math.max(purchaseFreq, turnover, 0);
        row.safe_purchase_freq = validFreq;
        if (validFreq > 0) {
          row.recommend_safe = Math.ceil(recommendTarget - (sale / validFreq));
        } else {
          row.recommend_safe = recommendTarget;
        }
      }

      // 强制更新视图
      this.$forceUpdate();
    },
    // 手调时的输入变化
    onRecommendChange(row) {
      // 当手调模式下，输入变化时自动计算预估达成率（已在计算方法中实现）
      // 标记数据已修改
      this.$set(row, '_changed', true);

      const sale = Number(row.sale_30_num) || 0;
      const recommendTarget = Number(row.recommend_target) || 0;
      const currentSafe = Number(row.item_stock_safe) || 0;
      const purchaseFreq = Number(row.safe_purchase_freq) || 1;

      // 如果安全库存是"不调"模式，需要重新计算补货次数
      if (row.safe_strategy === '不调') {
        const turnover = Number(row.recommend_turnover) || Number(row.turnoverdays) || 0;
        row.recommend_safe = currentSafe;
        const denominator = recommendTarget - currentSafe;
        if (denominator > 0) {
          let calcFreq = Math.ceil(sale / denominator);
          // 补货次数不能小于周转率，不能小于0
          row.safe_purchase_freq = Math.max(calcFreq, turnover, 0);
        } else {
          row.safe_purchase_freq = Math.max(turnover, 0);
        }
      }

      // 如果安全库存是"快调"模式，需要重新计算推荐安全库存
      if (row.safe_strategy === '快调') {
        const turnover = Number(row.recommend_turnover) || Number(row.turnoverdays) || 0;
        // 验证并修正补货次数：不能小于周转率，不能小于0
        let validFreq = Math.max(purchaseFreq, turnover, 0);
        row.safe_purchase_freq = validFreq;
        if (validFreq > 0) {
          row.recommend_safe = Math.ceil(recommendTarget - (sale / validFreq));
        } else {
          row.recommend_safe = recommendTarget;
        }
      }

      this.$forceUpdate();
    },
    // 安全库存调整策略变化
    onSafeStrategyChange(row) {
      const strategy = row.safe_strategy;
      const sale = Number(row.sale_30_num) || 0;
      const recommendTarget = Number(row.recommend_target) || 0;
      const currentSafe = Number(row.item_stock_safe) || 0;
      const purchaseFreq = Number(row.procurement_frequency) || 1;

      if (strategy === '不调') {
        // 不调：推荐保持为当前安全库存，根据公式反推计算补货次数
        // 公式：补货次数 = 总销量 / (目标推荐 - 当前安全库存)（向上取整）
        // 约束：补货次数不能小于周转率，不能小于0
        const turnover = Number(row.recommend_turnover) || Number(row.turnoverdays) || 0;
        row.recommend_safe = currentSafe;
        const denominator = recommendTarget - currentSafe;
        if (denominator > 0) {
          let calcFreq = Math.ceil(sale / denominator);
          // 补货次数不能小于周转率，不能小于0
          row.safe_purchase_freq = Math.max(calcFreq, turnover, 0);
        } else {
          row.safe_purchase_freq = Math.max(turnover, 0);
        }
        // 标记数据已修改
        this.$set(row, '_changed', true);
      } else if (strategy === '快调') {
        // 快调：补货次数保持不变，根据公式计算推荐安全库存（向上取整）
        // 公式：推荐安全库存 = 目标推荐 - (总销量/补货次数)
        // 约束：补货次数不能小于周转率，不能小于0
        const turnover = Number(row.recommend_turnover) || Number(row.turnoverdays) || 0;
        // 验证并修正补货次数
        let validFreq = Math.max(purchaseFreq, turnover, 0);
        row.safe_purchase_freq = validFreq;
        if (validFreq > 0) {
          row.recommend_safe = Math.ceil(recommendTarget - (sale / validFreq));
        } else {
          row.recommend_safe = recommendTarget;
        }
        // 标记数据已修改
        this.$set(row, '_changed', true);
      } else if (strategy === '手调') {
        // 手调：补货次数和推荐都可以手动输入（向上取整）
        // 预设：补货次数 = 周转率的1.5倍，推荐安全库存按照补货次数计算
        const turnover = Number(row.recommend_turnover) || Number(row.turnoverdays) || 0;
        // 补货次数 = 周转率 * 1.5（向上取整）
        let presetFreq = Math.ceil(turnover * 1.5);
        row.safe_purchase_freq = presetFreq;
        // 推荐安全库存按照计算的补货次数进行计算
        if (presetFreq > 0) {
          row.recommend_safe = Math.ceil(recommendTarget - (sale / presetFreq));
        } else {
          row.recommend_safe = recommendTarget;
        }
        // 标记数据已修改
        this.$set(row, '_changed', true);
      } else if (strategy === '不变') {
        // 不变：恢复默认值，清除修改标记
        row.safe_purchase_freq = purchaseFreq;
        row.recommend_safe = currentSafe;
        // 清除修改标记（如果目标库存也是不变状态）
        if (row.target_strategy === '不变') {
          this.$set(row, '_changed', false);
        }
      }

      // 强制更新视图
      this.$forceUpdate();
    },
    // 安全库存：补货次数变化（手调时）
    onSafePurchaseChange(row) {
      // 允许用户清空输入框，只在失去焦点或有具体数值时才验证
      // 标记数据已修改
      this.$set(row, '_changed', true);
      this.$forceUpdate();
    },
    // 安全库存：推荐值变化（手调时）
    onSafeRecommendChange(row) {
      // 标记数据已修改
      this.$set(row, '_changed', true);
      this.$forceUpdate();
    },
    // 目标库存推荐值失去焦点验证
    onTargetBlur(row) {
      if (row.recommend_target === '' || row.recommend_target === null) {
        row.recommend_target = 0;
      }
      this.$forceUpdate();
    },
    // 推荐周转率失去焦点验证
    onTurnoverBlur(row) {
      if (row.recommend_turnover === '' || row.recommend_turnover === null) {
        row.recommend_turnover = 0;
      }
      this.$forceUpdate();
    },
    // 补货次数失去焦点验证
    onSafePurchaseBlur(row) {
      const turnover = Number(row.recommend_turnover) || Number(row.turnoverdays) || 0;

      if (row.safe_purchase_freq === '' || row.safe_purchase_freq === null) {
        row.safe_purchase_freq = turnover;
      } else {
        let inputFreq = Number(row.safe_purchase_freq) || 0;
        if (inputFreq < 0) {
          row.safe_purchase_freq = 0;
          this.$message.warning('补货次数不能小于0');
        } else if (inputFreq < turnover) {
          row.safe_purchase_freq = turnover;
          this.$message.warning(`补货次数不能小于周转率(${turnover})`);
        }
      }
      this.$forceUpdate();
    },
    // 推荐安全库存失去焦点验证
    onSafeRecommendBlur(row) {
      if (row.recommend_safe === '' || row.recommend_safe === null) {
        row.recommend_safe = 0;
      }
      this.$forceUpdate();
    },
    safeInt(val) {
      const n = Number(val);
      if (!isFinite(n)) return 0;
      return n < 0 ? 0 : n;
    },
    // 单条保存
    saveOne(row) {
      const payload = {
        shop_id: this.basicListconfig.searchParameters.shop_id,
        item_id: row.item_id,
        turnoverdays: Number(row.recommend_turnover) || Number(row.turnoverdays) || 0,
        procurement_frequency: Number(row.safe_purchase_freq) || Number(row.procurement_frequency) || 0,
        item_stock_target: Number(row.recommend_target) || Number(row.item_stock_target) || 0,
        item_stock_safe: Number(row.recommend_safe) || Number(row.item_stock_safe) || 0,
      };
      // 表单提交
      const formData = { ...payload };
      if (!payload.shop_id) {
        this.$message.warning('请选择门店');
        return;
      }
      this.$set(row, '_saving', true);
      this.$apiSaveTargets(formData)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('更新成功');
            row.updateday = res.updateday || row.updateday;
            row.item_stock_safe = payload.item_stock_safe;
            row.item_stock_target = payload.item_stock_target;
            row.turnoverdays = payload.turnoverdays;
            row.procurement_frequency = payload.procurement_frequency;
            // 重置调整策略
            row.target_strategy = '不变';
            row.safe_strategy = '不变';
            // 清除修改标记
            this.$set(row, '_changed', false);
          } else {
            this.$message.error(res.msg || '更新失败');
          }
        })
        .finally(() => {
          this.$set(row, '_saving', false);
        });
    },
    // 全部更新
    saveAllChanged() {
      const shopId = this.basicListconfig.searchParameters.shop_id;
      if (!shopId) {
        this.$message.warning('请选择门店');
        return;
      }

      // 筛选出所有修改过的数据
      const changedRows = this.basicListconfig.data.filter(row => row._changed);
      if (!changedRows.length) {
        this.$message.warning('没有需要更新的数据');
        return;
      }

      const items = changedRows.map((row) => ({
        item_id: row.item_id,
        turnoverdays: Number(row.recommend_turnover) || Number(row.turnoverdays) || 0,
        procurement_frequency: Number(row.safe_purchase_freq) || Number(row.procurement_frequency) || 0,
        item_stock_target: Number(row.recommend_target) || Number(row.item_stock_target) || 0,
        item_stock_safe: Number(row.recommend_safe) || Number(row.item_stock_safe) || 0,
      }));

      // 表单提交，items 需要是字符串
      const payload = { shop_id: shopId, items: JSON.stringify(items) };

      this.basicListconfig.loading = true;
      this.$apiSaveTargets(payload)
        .then((res) => {
        if (res.code == 200) {
            this.$message.success(`成功更新 ${changedRows.length} 条数据`);
            // 清除所有修改标记并重置策略
            changedRows.forEach(row => {
              this.$set(row, '_changed', false);
              row.target_strategy = '不变';
              row.safe_strategy = '不变';
            });
            // 重新获取列表数据
          this.getlist();
        } else {
            this.$message.error(res.msg || '批量更新失败');
        }
        })
        .finally(() => {
          this.basicListconfig.loading = false;
      });
    },
    handleSizeChange(val) {
      this.searchEvent(this.searchForm, "", val);
    },
    handleCurrentChange(val) {
      this.searchEvent(this.searchForm, val, "");
    },
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    getlist() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters.shop_id;
        }
        return item;
      });
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = this.compId;
      if (this.roleId == 4) {
        let shop_ids = this.basicListconfig.search[0].options
          .map((item) => item.value)
          .join(",");
        if (!this.basicListconfig.searchParameters.hasOwnProperty("shop_id")) {
          this.basicListconfig.searchParameters.shop_id = this.shopId || shop_ids;
        }
        if (
          this.basicListconfig.searchParameters.hasOwnProperty("shop_id") &&
          this.basicListconfig.searchParameters.shop_id == ""
        ) {
          this.basicListconfig.searchParameters.shop_id = this.shopId || shop_ids;
        }
      }
      getTargetStockList(this.basicListconfig.searchParameters)
        .then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.total = Number(res.count || 0);
            // 初始化数据，添加调整策略字段
            this.basicListconfig.data = Array.isArray(res.data) ? res.data.map(item => {
              return {
                ...item,
                target_strategy: '不变', // 默认调整策略
                safe_strategy: '不变',
                recommend_target: item.item_stock_target || 0, // 默认推荐值为当前值
                recommend_turnover: item.turnoverdays || 0,
                recommend_safe: item.item_stock_safe || 0,
                safe_purchase_freq: item.procurement_frequency || 0, // 安全库存补货次数
                _changed: false, // 标记是否修改过
              };
            }) : [];
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
        })
        .catch((err) => {
          this.basicListconfig.loading = false;
          this.$message.error('获取数据失败：' + err.message);
      });
    },
    // 获取门店数据源
    getShops() {
      if (this.roleId == 4) {
        return userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          permission_id: this.getPermissionId("库存-库存查询-查看"),
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            const shopOptions = res.data.map((row) => {
              return { label: row.name, value: Number(row.id) };
            });
            const defaultShop = JSON.parse(getRoles()).shop_id;

            // 设置目标库存管理的门店选项
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = shopOptions;
                item.value = defaultShop;
              }
              return item;
            });

            // 设置修改日志的门店选项
            this.logListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = shopOptions;
                item.value = defaultShop;
              }
              return item;
            });

            // 设置已移除商品的门店选项
            this.removedListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = shopOptions;
                item.value = defaultShop;
              }
              return item;
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });
      } else {
        return getshoplist({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            const shopOptions = res.data.map((row) => {
              return { label: row.name, value: Number(row.id) };
            });

            // 设置目标库存管理的门店选项
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = shopOptions;
              }
              return item;
            });

            // 设置修改日志的门店选项
            this.logListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = shopOptions;
              }
              return item;
            });

            // 设置已移除商品的门店选项
            this.removedListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = shopOptions;
              }
              return item;
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });
      }
    },
    obtainDataSource() {
      return Promise.all([this.getShops(), this.getItemClasses()]);
    },
    // 获取商品分类数据源
    getItemClasses() {
      return itemClassGetList().then((res) => {
        if (res.code == 1) {
          const classOptions = this.$findChildren(0, res.data);

          // 设置目标库存管理的分类选项
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = classOptions;
            }
            return item;
          });

          // 设置已移除商品的分类选项
          this.removedListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = classOptions;
            }
            return item;
          });
        } else {
          this.$message.error(res.msg || "获取商品分类数据源失败！");
        }
      });
    },
    // 统一封装请求调用
    $apiSaveTargets(data) {
      // 动态引入，避免循环依赖
      const { saveTargets } = require('@/api/inventoryFlow');
      return saveTargets(data);
    },
    // 初始化目标库存
    initTargets() {
      this.$confirm('初始化会根据每个商品近30的采购次数进行重置操作', '确认初始化', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$apiInitTargets({ shop_id: this.basicListconfig.searchParameters.shop_id })
          .then(res => {
            if (res.code == 200) {
              this.$message.success('初始化成功');
              this.getlist(); // 重新获取列表数据
            } else {
              this.$message.error(res.data.msg || '初始化失败');
            }
          })
          .catch(err => {
            this.$message.error('初始化失败：' + err.message);
          });
      }).catch(() => {
        // 用户取消操作
      });
    },
    // 统一封装初始化接口调用
    $apiInitTargets(data) {
      // 动态引入，避免循环依赖
      const { initTargets } = require('@/api/inventoryFlow');
      return initTargets(data);
    },
    // Tab切换事件
    changeTabs(id) {
      this.activeId = id;
      if (id == 1) {
        // 在目标库存管理页
      } else if (id == 2) {
        // 切换到修改日志时，如果还没有数据，自动加载
        if (!this.logListconfig.data.length) {
          this.getLogList();
        }
      } else if (id == 3) {
        // 切换到已移除商品时，自动加载
        if (!this.removedListconfig.data.length) {
          this.getRemovedList();
        }
      }
    },
    // 获取修改日志列表
    getLogList() {
      this.logListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.logListconfig.searchParameters.shop_id;
        }
        return item;
      });
      this.logListconfig.loading = true;
      this.logListconfig.searchParameters.comp_id = this.compId;

      // 处理门店权限
      if (this.roleId == 4) {
        let shop_ids = this.logListconfig.search[0].options
          .map((item) => item.value)
          .join(",");
        if (!this.logListconfig.searchParameters.shop_id) {
          this.logListconfig.searchParameters.shop_id = this.shopId || shop_ids;
        }
      } else {
        if (!this.logListconfig.searchParameters.shop_id) {
          this.logListconfig.searchParameters.shop_id = JSON.parse(getRoles()).shop_id;
        }
      }

      getChangeHistory(this.logListconfig.searchParameters)
        .then((res) => {
          if (res.code == 1) {
            this.logListconfig.loading = false;
            this.logListconfig.total = Number(res.count || 0);
            this.logListconfig.data = Array.isArray(res.data) ? res.data : [];
          } else {
            this.logListconfig.loading = false;
            this.$message.error(res.msg || '获取修改日志失败');
          }
        })
        .catch((err) => {
          this.logListconfig.loading = false;
          this.$message.error('获取修改日志失败：' + err.message);
        });
    },
    // 修改日志搜索事件
    searchLogEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.logListconfig.searchParameters.page = page;
        if (pageSize) this.logListconfig.searchParameters.limit = pageSize;
        this.getLogList();
      } else if (data) {
        for (const key in data) {
          this.logListconfig.searchParameters[key] = data[key];
        }
        this.logListconfig.searchParameters.page = 1;
        this.getLogList();
      }
    },
    // 修改日志分页-页码变化
    handleLogCurrentChange(val) {
      this.searchLogEvent(null, val, "");
    },
    // 修改日志分页-每页数量变化
    handleLogSizeChange(val) {
      this.searchLogEvent(null, "", val);
    },
    // 导出数据
    exportData() {
      const shopId = this.basicListconfig.searchParameters.shop_id;
      if (!shopId) {
        this.$message.warning('请选择门店');
        return;
      }

      // 构建导出参数（与列表查询参数一致）
      const exportParams = {
        shop_id: shopId,
        keywords: this.basicListconfig.searchParameters.keywords || '',
        class_id: this.basicListconfig.searchParameters.class_id || '',
        order_by: this.basicListconfig.searchParameters.order_by || '',
        order_type: this.basicListconfig.searchParameters.order_type || 'desc',
      };

      // 获取环境变量中的主机地址
      let host = '';
      switch (process.env.NODE_ENV) {
        case "prod":
          host = window.location.origin;
          break;
        case "dev":
          host = this.apiBase;
          break;
        case "local":
          host = this.apiBase;
          break;
        default:
          host = window.location.origin;
      }

      const url = host + "/admin/Stock_target/export_data";

      this.$message.info('正在导出数据，请稍候...');

      axios({
        method: "GET",
        url: url,
        params: exportParams,
        responseType: "blob",
        headers: {
          "x-token": getSession(),
        },
      })
        .then((response) => {
          // 创建 Blob 对象
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
          // 生成下载链接
          const downloadUrl = window.URL.createObjectURL(blob);
          // 创建临时 <a> 标签
          const link = document.createElement("a");
          link.href = downloadUrl;
          // 设置下载文件名
          const filename = '目标库存数据_' + new Date().getTime() + '.csv';
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
          this.$message.success('导出成功');
        })
        .catch((error) => {
          console.error("导出文件失败:", error);
          this.$message.error('导出失败，请稍后重试');
        });
    },
    // 移除单个商品
    removeOne(row) {
      this.$prompt('请输入移除原因（选填）', '移除商品', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '例如：已停售',
      }).then(({ value }) => {
        const shopId = this.basicListconfig.searchParameters.shop_id;
        if (!shopId) {
          this.$message.warning('请选择门店');
          return;
        }

        const payload = {
          shop_id: shopId,
          item_id: row.item_id,
          remark: value || '',
        };

        removeItem(payload).then((res) => {
          if (res.code == 200) {
            this.$message.success('移除成功');
            this.getlist(); // 刷新列表
          } else if (res.code == 0) {
            this.$message.error(res.msg || '移除失败');
          }
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    // 批量移除商品
    batchRemove() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择要移除的商品');
        return;
      }

      this.$prompt('请输入移除原因（选填）', '批量移除商品', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '例如：季节性商品，暂不管理',
      }).then(({ value }) => {
        const shopId = this.basicListconfig.searchParameters.shop_id;
        if (!shopId) {
          this.$message.warning('请选择门店');
          return;
        }

        const itemIds = this.multipleSelection.map(row => row.item_id);
        const payload = {
          shop_id: shopId,
          item_ids: JSON.stringify(itemIds),
          remark: value || '',
        };

        batchRemoveItems(payload).then((res) => {
          if (res.code == 200) {
            this.$message.success(`成功移除 ${res.data.success_count || itemIds.length} 个商品`);
            this.getlist(); // 刷新列表
          } else {
            this.$message.error(res.msg || '批量移除失败');
          }
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    // 恢复单个商品
    restoreOne(row) {
      this.$confirm('确定恢复该商品到目标库存管理？', '恢复商品', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const shopId = this.removedListconfig.searchParameters.shop_id;
        if (!shopId) {
          this.$message.warning('请选择门店');
          return;
        }

        const payload = {
          shop_id: shopId,
          item_id: row.item_id,
        };

        restoreItem(payload).then((res) => {
          if (res.code == 200) {
            this.$message.success('恢复成功');
            this.getRemovedList(); // 刷新已移除列表
          } else {
            this.$message.error(res.msg || '恢复失败');
          }
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    // 批量恢复商品
    batchRestore() {
      if (!this.removedMultipleSelection.length) {
        this.$message.warning('请选择要恢复的商品');
        return;
      }

      this.$confirm(`确定恢复选中的 ${this.removedMultipleSelection.length} 个商品到目标库存管理？`, '批量恢复商品', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const shopId = this.removedListconfig.searchParameters.shop_id;
        if (!shopId) {
          this.$message.warning('请选择门店');
          return;
        }

        const itemIds = this.removedMultipleSelection.map(row => row.item_id);
        const payload = {
          shop_id: shopId,
          item_ids: JSON.stringify(itemIds),
        };

        batchRestoreItems(payload).then((res) => {
          if (res.code == 200) {
            this.$message.success(`成功恢复 ${res.data.success_count || itemIds.length} 个商品`);
            this.getRemovedList(); // 刷新已移除列表
          } else {
            this.$message.error(res.msg || '批量恢复失败');
          }
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
    // 获取已移除商品列表
    getRemovedList() {
      this.removedListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.removedListconfig.searchParameters.shop_id;
        }
        return item;
      });
      this.removedListconfig.loading = true;

      // 处理门店权限
      if (this.roleId == 4) {
        let shop_ids = this.removedListconfig.search[0].options
          .map((item) => item.value)
          .join(",");
        if (!this.removedListconfig.searchParameters.shop_id) {
          this.removedListconfig.searchParameters.shop_id = this.shopId || shop_ids;
        }
      } else {
        if (!this.removedListconfig.searchParameters.shop_id) {
          this.removedListconfig.searchParameters.shop_id = JSON.parse(getRoles()).shop_id;
        }
      }

      getRemovedList(this.removedListconfig.searchParameters)
        .then((res) => {
          if (res.code == 1) {
            this.removedListconfig.loading = false;
            this.removedListconfig.total = Number(res.count || 0);
            this.removedListconfig.data = Array.isArray(res.data) ? res.data : [];
          } else {
            this.removedListconfig.loading = false;
            this.$message.error(res.msg || '获取已移除商品列表失败');
          }
        })
        .catch((err) => {
          this.removedListconfig.loading = false;
          this.$message.error('获取已移除商品列表失败：' + err.message);
        });
    },
    // 已移除商品搜索事件
    searchRemovedEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.removedListconfig.searchParameters.page = page;
        if (pageSize) this.removedListconfig.searchParameters.limit = pageSize;
        this.getRemovedList();
      } else if (data) {
        for (const key in data) {
          this.removedListconfig.searchParameters[key] = data[key];
        }
        this.removedListconfig.searchParameters.page = 1;
        this.getRemovedList();
      }
    },
    // 已移除商品分页-页码变化
    handleRemovedCurrentChange(val) {
      this.searchRemovedEvent(null, val, "");
    },
    // 已移除商品分页-每页数量变化
    handleRemovedSizeChange(val) {
      this.searchRemovedEvent(null, "", val);
    },
  },
};
</script>

<style scoped>
/* 修改过的行背景色 */
.table >>> .row-changed {
  background-color: #FFF9E6 !important;
}

.table >>> .row-changed:hover > td {
  background-color: #FFF4CC !important;
}

/* 调整策略下拉框样式 */
.strategy-select-不调 >>> .el-input__inner {
  background-color: #E6F7FF !important;
  border-color: #91D5FF !important;
  color: #1890FF !important;
  font-weight: 500;
}

.strategy-select-快调 >>> .el-input__inner {
  background-color: #FFF7E6 !important;
  border-color: #FFD591 !important;
  color: #FA8C16 !important;
  font-weight: 500;
}

.strategy-select-手调 >>> .el-input__inner {
  background-color: #F0F5FF !important;
  border-color: #ADC6FF !important;
  color: #597EF7 !important;
  font-weight: 500;
}

.strategy-select-不变 >>> .el-input__inner {
  background-color: #F5F5F5 !important;
  border-color: #D9D9D9 !important;
  color: #8C8C8C !important;
}

/* 空数据样式 */
.empty-data {
  padding: 40px 0;
  text-align: center;
}

.empty-data i {
  display: block;
  margin-bottom: 16px;
}

.empty-data p {
  font-size: 14px;
  color: #999;
  margin: 0;
}
</style>





// WEBPACK FOOTER //
// src/views/stockTarget/index.vue